export default {
	init() {
	  // JavaScript to be fired on the blog page
	  $(document).ready(function() {
		$('.col-left').find('.group-name').eq(0).addClass('active');
		$('.col-left').find('.service-all').eq(0).addClass('active');

		$('.group-name').on('click', function() {
		  if($(this).hasClass('active')){
			// $('.col-right').css({'opacity': '1'});
			$(this).removeClass('active');
			 $(this).parent().children('.service-all').removeClass('active');
		  } else {
			// $('.col-right').css({'opacity': '0'});
			$('.group-name').removeClass('active');
			$('.service-all').removeClass('active');
			$(this).addClass('active');
			$(this).parent().children('.service-all').addClass('active');
		  }
		});
	  });
	},
  };
  